import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import StatusBotIcon from '../../StatusBotIcon';
import { useAiCommandPalette } from '../context/AiCommandPaletteContext';

const AiOption = () => {
  const {
    inputValue,
    handleAiAsk,
    selectedIndex,
    isAskMode,
    conversationHistory,
    searchResults,
    setSelectedIndex
  } = useAiCommandPalette();

  // Don't show the AI option when in ask mode with a conversation
  if (isAskMode && conversationHistory.length > 0) return null;
  
  if (!inputValue.trim()) return null;

  // AI option is selected when selectedIndex equals the length of search results
  const isSelected = selectedIndex === searchResults.length;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      onClick={() => {
        if (inputValue.trim()) {
          handleAiAsk();
        }
      }}
      onMouseMove={() => setSelectedIndex(searchResults.length)}
      className={`p-3 rounded-lg cursor-pointer group transition-colors ${
        isSelected
          ? 'bg-violet-50 dark:bg-violet-500/10'
          : ''
      }`}
    >
      <div className="flex items-start gap-3">
        <div className="pt-1">
          <StatusBotIcon className="h-5 w-5 text-teal-500" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-normal text-foreground transition-colors">
            Ask StatusBot "<span className="font-bold">{inputValue}</span>"
          </div>
          <div className="text-sm text-muted-foreground flex items-center gap-2 mt-1">
            Get AI-powered insights about your organization
          </div>
        </div>
        <div className="flex items-center self-center">
          <ChevronRight className={`h-4 w-4 text-muted-foreground transition-opacity ${
            isSelected ? 'opacity-100' : 'opacity-0'
          }`} />
        </div>
      </div>
    </motion.div>
  );
};

export default AiOption; 